export { default as InventoryItemInfo } from './InventoryItemInfo';

